// Scroll-pinned card columns ([data-scroll-pin]).
// On desktop the section pins to the viewport (via a sticky inner) and the cards
// translate vertically in sync with page scroll, so the user can only scroll past
// the section once every card has scrolled through. On mobile / reduced-motion the
// cards stack and scroll normally.

const DESKTOP = window.matchMedia("(min-width: 1024px)");
const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

function initScrollPin(section) {
    const track = section.querySelector(".js-pin-track");
    const viewport = section.querySelector(".js-pin-viewport");
    const cards = section.querySelector(".js-pin-cards");
    if (!track || !viewport || !cards) return;

    const inner = section.querySelector(".js-pin-inner");
    let overflow = 0;
    let topOffset = 0;
    let ticking = false;

    const reset = () => {
        track.style.height = "";
        cards.style.transform = "";
        if (inner) inner.style.top = "";
    };

    const measure = () => {
        if (!DESKTOP.matches || REDUCED.matches) {
            reset();
            overflow = 0;
            return;
        }
        // how much taller the stacked cards are than the visible viewport
        overflow = Math.max(0, cards.scrollHeight - viewport.clientHeight);
        if (overflow <= 0) {
            reset();
            return;
        }
        // keep the section at its natural height; pin it vertically centred in the
        // viewport (min 1rem from the top for short viewports)
        const naturalH = inner.offsetHeight;
        topOffset = Math.max(16, (window.innerHeight - naturalH) / 2);
        inner.style.top = `${topOffset}px`;
        // track is taller than the section by exactly the card overflow, so the
        // section stays pinned just long enough to reveal every card
        track.style.height = `${naturalH + overflow}px`;
        update();
    };

    const update = () => {
        ticking = false;
        if (overflow <= 0) return;
        // progress 0→1 across the pinned window (geometry-based → robust to any
        // layout shift above the section)
        const progress = Math.min(1, Math.max(0,
            (topOffset - track.getBoundingClientRect().top) / overflow
        ));
        cards.style.transform = `translate3d(0, ${-(overflow * progress)}px, 0)`;
    };

    const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", measure);
    DESKTOP.addEventListener("change", measure);

    // recompute when card heights settle (fonts / late layout)
    if ("ResizeObserver" in window) {
        new ResizeObserver(measure).observe(cards);
    }
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure);
    }

    measure();
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-scroll-pin]").forEach(initScrollPin);
});
